var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row"},[_c('Info',{attrs:{"process":_vm.process},on:{"refresh":_vm.showLog}}),_c('div',{staticClass:"timeline"},[_c('Timeline',{attrs:{"process":_vm.process}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }